import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Formats phone number into national format. Expects a E.164 phone number
 * string coming from API.
 */
export function formatNational(phone: string): string {
  return parsePhoneNumberFromString(phone)?.formatNational() ?? "";
}

/**
 * Formats phone number into international format. Expects a E.164 phone number
 * string coming from API.
 */
export function formatInternational(phone: string): string {
  return parsePhoneNumberFromString(phone)?.formatInternational() ?? "";
}
